import { render, staticRenderFns } from "./Analysis.vue?vue&type=template&id=4b966165&scoped=true&lang=pug&"
import script from "./Analysis.vue?vue&type=script&lang=js&"
export * from "./Analysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b966165",
  null
  
)

export default component.exports